export const purchaseOrderTypes = {
  SET_SELECTED_ORDER: 'SET_SELECTED_ORDER',

  DELETE_REQUEST: 'DELETE_REQUEST',
  DELETE_SUCCESS: 'DELETE_SUCCESS',
  DELETE_FAILED: 'DELETE_FAILED',

  RESTORE_REQUEST: 'RESTORE_REQUEST',
  RESTORE_SUCCESS: 'RESTORE_SUCCESS',
  RESTORE_FAILED: 'RESTORE_FAILED',

  ADD_REQUEST: 'ADD_REQUEST',
  ADD_SUCCESS: 'ADD_SUCCESS',
  ADD_FAILED: 'ADD_FAILED'
};

export const getListTypes = {
  REQUEST: 'GET_PURCHASE_ORDERS_REQUEST',
  SUCCESS: 'GET_PURCHASE_ORDERS_SUCCESS',
  FAILED: 'GET_PURCHASE_ORDERS_FAILED'
};

export const getByIdTypes = {
  REQUEST: 'GET_PURCHASEORDER_BYID_REQUEST',
  SUCCESS: 'GET_PURCHASEORDER_BYID_SUCCESS',
  FAILED: 'GET_PURCHASEORDER_BYID_FAILED'
};

export const deliveryVoucherTypes = {
  GET_REQUEST: 'GET_DELIVERY_VOUCHERS_REQUEST',
  GET_SUCCESS: 'GET_DELIVERY_VOUCHERS_SUCCESS',
  GET_FAILED: 'GET_DELIVERY_VOUCHERS_FAILED',

  ADD_REQUEST: 'ADD_DELIVERY_VOUCHER_REQUEST',
  ADD_SUCCESS: 'ADD_DELIVERY_VOUCHER_SUCCESS',
  ADD_FAILED: 'ADD_DELIVERY_VOUCHER_FAILED',

  DELETE_REQUEST: 'DELETE_DELIVERY_VOUCHER_REQUEST',
  DELETE_SUCCESS: 'DELETE_DELIVERY_VOUCHER_SUCCESS',
  DELETE_FAILED: 'DELETE_DELIVERY_VOUCHER_FAILED'
};

export const invoiceFileTypes = {
  GET_REQUEST: 'GET_INVOICE_FILES_REQUEST',
  GET_SUCCESS: 'GET_INVOICE_FILES_SUCCESS',
  GET_FAILED: 'GET_INVOICE_FILES_FAILED',

  ADD_REQUEST: 'ADD_INVOICE_FILE_REQUEST',
  ADD_SUCCESS: 'ADD_INVOICE_FILE_SUCCESS',
  ADD_FAILED: 'ADD_INVOICE_FILE_FAILED',

  DELETE_REQUEST: 'DELETE_INVOICE_FILE_REQUEST',
  DELETE_SUCCESS: 'DELETE_INVOICE_FILE_SUCCESS',
  DELETE_FAILED: 'DELETE_INVOICE_FILE_FAILED'
}

export const associatedInvoiceTypes = {
  GET_REQUEST: 'GET_ASSOCIATED_INVOICES_REQUEST',
  GET_SUCCESS: 'GET_ASSOCIATED_INVOICES_SUCCESS',
  GET_FAILED: 'GET_ASSOCIATED_INVOICES_FAILED',

  GET_INFO_REQUEST: 'GET_ASSOCIATED_INVOICES_INFO_REQUEST',
  GET_INFO_SUCCESS: 'GET_ASSOCIATED_INVOICES_INFO_SUCCESS',
  GET_INFO_FAILED: 'GET_ASSOCIATED_INVOICES_INFO_FAILED',

  ADD_REQUEST: 'ADD_ASSOCIATED_INVOICE_REQUEST',
  ADD_SUCCESS: 'ADD_ASSOCIATED_INVOICE_SUCCESS',
  ADD_FAILED: 'ADD_ASSOCIATED_INVOICE_FAILED',

  ADD_E_REQUEST: 'ADD_ASSOCIATED_ELECTRONIC_INVOICE_REQUEST',
  ADD_E_SUCCESS: 'ADD_ASSOCIATED_ELECTRONIC_INVOICE_SUCCESS',
  ADD_E_FAILED: 'ADD_ASSOCIATED_ELECTRONIC_INVOICE_FAILED',

  DELETE_REQUEST: 'DELETE_ASSOCIATED_INVOICE_REQUEST',
  DELETE_SUCCESS: 'DELETE_ASSOCIATED_INVOICE_SUCCESS',
  DELETE_FAILED: 'DELETE_ASSOCIATED_INVOICE_FAILED'
};

export const requestPaymentTypes = {
  REQUEST: 'REQUEST_PAYMENT_REQUEST',
  SUCCESS: 'REQUEST_PAYMENT_SUCCESS',
  FAILED: 'REQUEST_PAYMENT_FAILED',

  CHANGE_STATE_REQUEST: 'CHANGE_STATE_REQUEST',
  CHANGE_STATE_SUCCESS: 'CHANGE_STATE_SUCCESS',
  CHANGE_STATE_FAILED: 'CHANGE_STATE_FAILED',
  CHANGE_STATE_SOME_INOVICES_ARE_FAILED: 'CHANGE_STATE_SOME_INOVICES_ARE_FAILED',
  CLOSE_FEEDBACK_MODAL: 'CLOSE_FEEDBACK_MODAL'
};

export const requestAutomatedPaymentTypes = {
  REQUEST: 'REQUEST_AUTOMATED_PAYMENT_REQUEST',
  SUCCESS: 'REQUEST_AUTOMATED_PAYMENT_SUCCESS',
  FAILED: 'REQUEST_AUTOMATED_PAYMENT_FAILED'
};

export const sortPurchaseOrders = {
  SORT: 'SORT_PURCHASE_ORDERS'
};
